import { createStyles, makeStyles, Tooltip } from "@material-ui/core";
import { domain } from "core/src";
import * as React from "react";

import { Text } from "../";
import { InfoIcon } from "../../assets/icons";
import { JobPriorityType, UserRole } from "../../domain";
import { getUserFromStorage } from "../../modules";
import { RelodeTheme } from "../styles";

const useStyles = makeStyles((theme: RelodeTheme) =>
    createStyles({
        tooltip: {
            backgroundColor: "#fff",
            boxShadow:
                "0px 10px 10px 0px rgba(0, 0, 0, 0.1), 0px 10px 10px 0px rgba(0, 0, 0, 0.1)",
        },
        infoRoot: {
            display: "flex",
            verticalAlign: "middle",
            cursor: "pointer",
        },
        info: {
            padding: theme.spacing(2),
        },
        jobPriorityText: {
            padding: theme.spacing(2, 2, 0, 2),
        },
    })
);

interface JobPriorityLegendProps {
    children?: React.ReactElement<any, any>;
    withGradeIcon: boolean;
}

export const JobPriorityLegend = (props: JobPriorityLegendProps) => {
    const classes = useStyles();
    const { withGradeIcon } = props;

    const [showTooltip, setShowToolTip] = React.useState<boolean>(false);

    const user = getUserFromStorage();

    return (
        <Tooltip
            placement="right-end"
            open={showTooltip}
            onOpen={() => setShowToolTip(true)}
            onClose={() => setShowToolTip(false)}
            title={<JobPriorityToolTip role={user.role} />}
            classes={{ tooltip: classes.tooltip }}
            enterTouchDelay={0}
            leaveTouchDelay={5000}
        >
            {withGradeIcon ? (
                <span
                    className={classes.infoRoot}
                    onClick={() => setShowToolTip(!showTooltip)}
                >
                    {props.children}
                </span>
            ) : (
                <div>
                    <InfoIcon
                        fontSize="inherit"
                        color="primary"
                        classes={{ root: classes.infoRoot }}
                    />
                </div>
            )}
        </Tooltip>
    );
};

interface JobPriorityToolTipProps {
    role: domain.UserRole;
}

const JobPriorityToolTip = (props: JobPriorityToolTipProps) => {
    const classes = useStyles();
    const { role } = props;

    const getPriorityDescriptionByUserRole = (
        roleId: number,
        jobPriorityType: JobPriorityType
    ): string => {
        switch (roleId) {
            case UserRole.Administrator.roleId:
            case UserRole.Accounting.roleId:
                return jobPriorityType.adminDescription;
            case UserRole.Recruiter.roleId:
            case UserRole.Sourcer.roleId:
                return jobPriorityType.recruiterDescription;
            case UserRole.Client.roleId:
            case UserRole.ClientAdmin.roleId:
                return jobPriorityType.clientDescription;
            default:
                return jobPriorityType.recruiterDescription;
        }
    };

    return (
        <>
            {JobPriorityType.asArray().map(jpt => (
                <Text
                    className={classes.jobPriorityText}
                    gutterBottom
                    variant="body1"
                    key={jpt.id}
                >
                    {jpt.grade}
                    {" - "}
                    {getPriorityDescriptionByUserRole(role.roleId, jpt)}
                </Text>
            ))}
        </>
    );
};
